import ApiUtils from '@/api/util/ApiUtils';
import TypeUtils from '@/api/util/TypeUtils';
import {OrderFragment_ticketDefinitions} from '@/api/gql/gql-types/OrderFragment';

export default class TicketDefinitionDTO {

  public static fromModel(objs: OrderFragment_ticketDefinitions[]) {
    const data: TicketDefinitionDTO[] = [];
    for (const obj of objs) {
      const datum: TicketDefinitionDTO = {
        id: obj.id,
        name: obj.name,
        sortIndex: obj.sortIndex,
        showRemainingQuantity: obj.showRemainingQuantity || false,
        // consider using integer cents instead of floats if we have to do more than a little math with these
        price: obj.price ? Number(obj.price) : null,
        promoPrice: obj.promoPrice ? Number(obj.promoPrice) : null,
        description: ApiUtils.nullToEmpty(obj.description),
        promoCode: null,
        attendee: {},
        quantity: obj.remainingCount as (number | null),
        survey: obj.survey,
      };
      data.push(datum);
    }

    return data;
  }

  public id: string = '';
  public name: string = '';
  public sortIndex: number = 0;
  public description: string = '';
  public quantity: number | null = null;
  public showRemainingQuantity: boolean = true;
  public promoCode: string | null = null;
  public price: number | null = null;
  public promoPrice: number | null = null;
  public survey: object | null = { };
  public attendee: object | null = { };
}

